App.SmSegmentedComponent = Em.Component.extend
  classNames: [ 'sm-segmented' ]
  classNameBindings: [ 'segmentSize' ]

  segmentSize: (->
    'sm-segment-size-' + @get('availableOptions.length')
  ).property('availableOptions.length')
  value: ''

  setOptions: (->
    @set('availableOptions', [])
    @get('selectedValue.name')
  ).on('init')


App.SmSegmentComponent = Em.Component.extend
  classNames: [ 'sm-segment' ]
  classNameBindings: [ 'isActive:active', 'disabled:disabled' ]

  option: ''
  valueBinding:    'parentView.value'
  onChangeBinding: 'parentView.onChange'
  disabled: false

  register: (->
    @get('parentView.availableOptions').pushObject(@get('option'))
  ).on('didInsertElement')

  unregister: (->
    @get('parentView.availableOptions').removeObject(@get('option'))
  ).on('willDestroyElement')

  click: ->
    if @get('value') isnt @get('option')
      @set('value', @get('option'))
      @sendAction('onChange', @get('option'))

  isActive: (->
    @get('option') is @get('value')
  ).property('option', 'value')





